import React, { useState, useCallback } from "react";
import { useAppSelector } from "../../hooks/redux";
import { Chips, ChipData } from "../Chips/Chips";
import { EventsList } from "../EventList/EventsList";
import styles from "./FullscreenSummary.module.css";
import { Event, Webcam } from "../../types";
import { useTheme } from "@/hooks/useTheme";
import { WebcamViewer } from "../WebcamViewer/WebcamViewer";
// Используем те же иконки, что и в модальной версии
import DpsChipIconLight from "../icons/chips/light/dps.svg?react";
import ClearChipIconLight from "../icons/chips/light/clear.svg?react";
import DtpChipIconLight from "../icons/chips/light/dtp.svg?react";
import WebcamIconLight from "../icons/chips/light/webcam.svg?react";

import DpsChipIconDark from "../icons/chips/dark/dps.svg?react";
import ClearChipIconDark from "../icons/chips/dark/clear.svg?react";
import DtpChipIconDark from "../icons/chips/dark/dtp.svg?react";
import WebcamIconDark from "../icons/chips/dark/webcam.svg?react";

interface FullscreenSummaryProps {
  onOpenMap: () => void;
  onLocationClarificationRequest?: (data: {
    event: Event;
    title: string;
    coordinates: [number, number];
  }) => void;
}

export const FullscreenSummary: React.FC<FullscreenSummaryProps> = ({
  onOpenMap,
  onLocationClarificationRequest,
}) => {
  const [selectedChip, setSelectedChip] = useState<string>("dps");
  const [selectedWebcamInSummary, setSelectedWebcamInSummary] =
    useState<Webcam | null>(null);
  const { events, webcams, selectedCity } = useAppSelector(
    (state) => state.map
  );

  const handleChipClick = useCallback((chipId: string) => {
    setSelectedChip(chipId);
  }, []);

  const handleWebcamSelect = useCallback((webcam: Webcam) => {
    setSelectedWebcamInSummary(webcam);
  }, []);

  const { theme } = useTheme();

  // Используем те же иконки и структуру, что в модальной версии
  const chips: ChipData[] = [
    {
      id: "dps",
      icon: theme === "dark" ? <DpsChipIconDark /> : <DpsChipIconLight />,
      text: "ДПС",
    },
    {
      id: "clean",
      icon: theme === "dark" ? <ClearChipIconDark /> : <ClearChipIconLight />,
      text: "Чисто",
    },
    {
      id: "accident",
      icon: theme === "dark" ? <DtpChipIconDark /> : <DtpChipIconLight />,
      text: "ДТП",
    },
    {
      id: "webcams",
      icon: theme === "dark" ? <WebcamIconDark /> : <WebcamIconLight />,
      text: "Камеры",
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Сводка</h1>
        <p className={styles.cityName}>{selectedCity?.name}</p>
      </div>

      <div className={styles.chipsContainer}>
        <Chips
          chips={chips}
          selectedChip={selectedChip}
          onChipClick={handleChipClick}
        />
      </div>

      <div className={styles.eventsContainer}>
        {selectedWebcamInSummary ? (
          <WebcamViewer
            webcam={selectedWebcamInSummary}
            onBack={() => setSelectedWebcamInSummary(null)}
          />
        ) : (
          <EventsList
            events={events}
            webcams={webcams}
            selectedType={selectedChip}
            onLocationClarificationRequest={onLocationClarificationRequest}
            onWebcamSelect={handleWebcamSelect}
          />
        )}
      </div>

      <div className={styles.footer}>
        <button className={styles.openMapButton} onClick={onOpenMap}>
          Открыть карту
        </button>
      </div>
    </div>
  );
};
